exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link-item[data-v-1711c0f2] {\n  display: flex;\n  align-items: stretch;\n  padding-right: 0.5rem;\n}\n.link-item-link[data-v-1711c0f2], .link-item-edit[data-v-1711c0f2] {\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n}\n.link-item-link[data-v-1711c0f2]:hover, .link-item-edit[data-v-1711c0f2]:hover {\n  color: var(--secondary);\n}\n.link-item-link[data-v-1711c0f2] {\n  transition-property: color;\n}\n.link-item-name[data-v-1711c0f2] {\n  padding-right: 1rem;\n}\n.link-item.editing .link-item-link[data-v-1711c0f2] {\n  flex-grow: 0;\n}", ""]);

// exports
